<!--eslint-disable-->
<template>
    <el-container>
        <el-main class="main">
            <div id="rules-content">
                <el-dialog :visible.sync="dialogDistributorRuleVisible">
                    <el-form :model="newDistributorRule">
                        <el-form-item label="Distribuidora">
                            <el-input v-model="newDistributorRule.distribuidora"></el-input>
                        </el-form-item>
                        <el-form-item label="Ativo">
                            <template>
                                <el-radio v-model="newDistributorRule.ativo" label="true">Sim</el-radio>
                                <el-radio v-model="newDistributorRule.ativo" label="false">Não</el-radio>
                            </template>
                        </el-form-item>
                        <el-form-item label="% ADM">
                            <el-input v-model="newDistributorRule.percAdm"></el-input>
                        </el-form-item>
                        <el-form-item label="% PERF">
                            <el-input v-model="newDistributorRule.percPerf"></el-input>
                        </el-form-item>
                        <el-form-item label="Líquido ou bruto">
                            <template>
                                <el-radio v-model="newDistributorRule.liquidoBruto" label="liquido">Líquido</el-radio>
                                <el-radio v-model="newDistributorRule.liquidoBruto" label="bruto">Bruto</el-radio>
                            </template>
                        </el-form-item>
                        <el-form-item label="Data">
                            <el-input v-model="newDistributorRule.data"></el-input>
                        </el-form-item>
                        <el-form-item label="Observações">
                            <el-input type="textarea" v-model="newDistributorRule.observacoes"></el-input>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="cancelarAdicionarRegra">Cancelar</el-button>
                        <el-button type="primary" @click="adicionarRegra">Adicionar</el-button>
                    </span>
                </el-dialog>
                <div class="header-manual">
                    <span>Tabela de regras</span>
                    <el-button @click="showDistributorRuleForm" type="primary" style="margin-left: 10px">+</el-button>
                </div>
                <div id="rules-content-column-1">
                    <div id="table-distribuidors">
                        <el-table
                            v-loading="loadingDistributor"
                            :data="tableRules"
                            border
                            size="mini"
                            stripe>
                            <el-table-column
                                sortable
                                prop="distribuidora"
                                label="Distribuidora"
                                align="center"
                                width="250">
                                <template slot-scope="scope">
                                    <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarRegra"></NewEditableColumn>
                                </template>
                            </el-table-column>
                            <el-table-column
                                sortable
                                prop="ativo"
                                label="Ativo"
                                align="center"
                                width="100">
                                <template slot-scope="scope">
                                    <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarRegra"></NewEditableColumn>
                                </template>
                            </el-table-column>
                            <el-table-column
                                sortable
                                prop="percAdm"
                                label="% ADM"
                                align="center"
                                width="100">
                                <template slot-scope="scope">
                                    <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarRegra"></NewEditableColumn>
                                </template>
                            </el-table-column>
                            <el-table-column
                                sortable
                                prop="percPerf"
                                label="% PERF"
                                align="center"
                                width="100">
                                <template slot-scope="scope">
                                    <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarRegra"></NewEditableColumn>
                                </template>
                            </el-table-column>
                            <el-table-column
                            sortable
                                prop="liquidoBruto"
                                label="Liquido ou Bruto"
                                align="center"
                                width="150">
                                <template slot-scope="scope">
                                    <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarRegra"></NewEditableColumn>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="data"
                                label="Data"
                                align="center"
                                width="100">
                                <template slot-scope="scope">
                                    <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarRegra"></NewEditableColumn>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="observacoes"
                                label="Observações"
                                align="center"
                                width="350">
                                <template slot-scope="scope">
                                    <NewEditableColumn :scope="scope" v-on:saveToFirestore="alterarRegra"></NewEditableColumn>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="delete"
                                align="center"
                                width="50"> 
                                <template slot-scope="scope">
                                    <div class="header-details">
                                        <span @click="removerRegra(scope)"><i class="el-icon-delete"></i></span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <br style="clear:both"/>
            </div>
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import firebase from 'firebase/app'
import fb from '@/services/firebaseConfig'
import NewEditableColumn from '@/components/NewEditableColumn.vue'
import format from 'xml-formatter'
import regex from '@/services/regex'

const db = fb.db

export default {
    data() {
        return {
            loading: true,
            loadingDistributor: false,
            refDate: null,
            chosenDate: new Date(),
            table: null,
            dialogDistributorRuleVisible: false,
            newDistributorRule: {
                distribuidora: '',
                ativo: '',
                percAdm: '',
                percPerf: '',
                liquidoBruto: '',
                data: '',
                observacoes: ''
            },
            rulesTable: [],
            file: Object,
        }
    },
    components: {
        NewEditableColumn
    },
    methods: {
        showDistributorRuleForm() {
            this.dialogDistributorRuleVisible = true;
        },
        async removerRegra(scope) {
            try {
                await db.collection('rebateRegrasCadastro').doc(scope.row.docId).delete()
            } catch(err) {
                console.log(err)
                this.$root.$emit('showError', "Erro. Entre em contato com o administrador do site.", 'error')
            }
        },
        async alterarRegra(value, scope) {
            try {
                let data = {...scope.row}
                delete data.docId
                await db.collection('rebateRegrasCadastro').doc(scope.row.docId).set(data)
            } catch(err) {
                console.log(err)
                this.$root.$emit('showError', "Erro. Entre em contato com o administrador do site.", 'error')
            }
        },
        async adicionarRegra() {            
            try {
                await db.collection('rebateRegrasCadastro').add(this.newDistributorRule)
                this.newDistributorRule = {
                    distribuidora: '',
                    ativo: '',
                    percAdm: '',
                    percPerf: '',
                    liquidoBruto: '',
                    data: '',
                    observacoes: ''
                }
                this.dialogDistributorRuleVisible = false
            } catch(err) {
                console.log(err)
                this.$root.$emit('showError', "Erro. Entre em contato com o administrador do site.", 'error')
            }
        },
        cancelarAdicionarRegra() {
            this.newDistributorRule = {
                distribuidora: '',
                ativo: '',
                percAdm: '',
                percPerf: '',
                liquidoBruto: '',
                data: '',
                observacoes: ''
            }
            this.dialogDistributorRuleVisible = false
        }
    },
    computed: {
        tableRules() {
            return this.rulesTable
        }
    },
    async created() {
        this.loading = true
        
        await db.collection('rebateRegrasCadastro')
            .onSnapshot(
                q => {
                    let auxTable = []
                    q.forEach(doc => {
                        auxTable.push({
                            docId: doc.id,
                            distribuidora: doc.data().distribuidora,
                            ativo: doc.data().ativo,
                            percAdm: doc.data().percAdm,
                            percPerf: doc.data().percPerf,
                            liquidoBruto: doc.data().liquidoBruto,
                            data: doc.data().data,
                            observacoes: doc.data().observacoes
                        })
                    })
                    this.rulesTable = auxTable
            })
                    
        this.loading = false
    },
}
</script>

<style scoped>
.el-input .el-input__inner {
    color: red;
}
.distributor {
    width: 1500px;
}
.el-dialog .main-title {
    font-weight: bold;
    font-size: 22px;
}
.el-dialog .title-detail {
    font-style: italic;
    font-size: 18px;
}
.rules-content {
    max-width: 800px;
}
.header-title {
    margin:0;
    font-weight:bold;
    font-size:14px;
    text-decoration:underline;
    color: #606266;
    height: 23px;
}
.el-header.header {
    width: 1485px;
    font-family: Calibri;
    color: #606266;
    padding: 0 10px;
    font-size: 20px;
    margin-bottom: 5px;
}
.header-manual {
    font-family: Calibri;
    color: #606266;
    font-size: 20px;
    margin-top: 20px;
    margin-bottom: 10px;
}
.header-details {
    text-align: center;
}
.el-table .cell {
    word-wrap: break-word;
}
.el-table .cell-size {
    padding: 1px 0;
    font-family: Calibri;
}
hr { 
    display: block;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    margin-left: auto;
    margin-right: auto;
    border-style: inset;
    border-width: 1px;
}
#table-distribuidors {
    position: relative;
    margin-top: 10px;
    margin-right: 20px;
}
#rules-content {
    content: "";
    display: table;
    clear: both;
}
</style>